import WizardPagetemplate from '../../templates/WizardPagetemplate';
import { Button, Grid, GridItem, LoadingDots } from '@flos/react-ui';
import CheckoutAccordion from './components/CheckoutAccordion';
import CheckoutSidebar from './components/CheckoutSidebar';
import { useHippoText } from '../../hooks/useHippoText';
import { useRecoilValue } from 'recoil';
import { externalCasesAtom } from '../../recoil/atoms/externalCasesAtom';
import { allCoverablesAtom } from '../../recoil/atoms/allCoverablesAtom';
import { getCheckoutConfig } from './configs/CheckoutAccordionConfig';
import type { WizardPageComponent } from '../../config/wizardPagesConfig';
import useWizardNavigation from '../../hooks/useWizardNavigation';
import { jobInfoAtom } from '../../recoil/atoms/jobInfoAtom';
import { containsAddCoverageChangeSelector } from '../../recoil/selectors/containsAddCoverageSelector';
import { notUpdatedCoverablesAtom } from '../../recoil/atoms/notUpdatedCoverablesAtom';
import CallMeModal from '../../shared_components/CallMeModal/CallMeModal';
import { useState } from 'react';
import useWindowSize from '../../hooks/useWindowSize';
import { accountHolderAtom } from '../../recoil/atoms/accountHolderAtom';

const CheckoutPage: WizardPageComponent = () => {
    const { wizardNextStep, wizardPreviousStep } = useWizardNavigation();
    const notUpdatedCoverables = useRecoilValue(notUpdatedCoverablesAtom);
    const getHippoText = useHippoText();
    const { isMobileDevice } = useWindowSize();
    const [showModal, setShowModal] = useState(false);
    const coverables = useRecoilValue(allCoverablesAtom);
    const externalCasesData = useRecoilValue(externalCasesAtom);
    const { isPolicyChange } = useRecoilValue(jobInfoAtom);
    const containsAddCoverageChange = useRecoilValue(containsAddCoverageChangeSelector);
    const { isCVR } = useRecoilValue(accountHolderAtom);

    const checkoutAccordions = getCheckoutConfig(
        coverables,
        externalCasesData,
        isPolicyChange ?? false,
        isCVR,
        containsAddCoverageChange,
        notUpdatedCoverables
    ).filter((accordion) => !accordion.disabled);

    if (checkoutAccordions.length === 0) {
        return <LoadingDots />;
    }

    return (
        <>
            <WizardPagetemplate
                onNext={wizardNextStep}
                onPrevious={wizardPreviousStep}
                hideNext
                hidePrevious
                showGiftCertificateBanner={false}
            >
                <Grid className={'u-shadow-none'}>
                    <GridItem span={12}>
                        <h3>{getHippoText('DSS-CHECKOUT-HEADER')}</h3>
                    </GridItem>
                    <GridItem span={7}>
                        <CheckoutAccordion
                            wizardNextStep={wizardNextStep}
                            CheckoutAccordionConfig={checkoutAccordions}
                        />
                    </GridItem>
                    <GridItem colStart={9} span={4}>
                        <CheckoutSidebar />
                        <div
                            className={
                                isMobileDevice
                                    ? 'u-floating-cta u-spacing-stack-bottom-10'
                                    : 'u-text-center u-spacing-inset-top-7'
                            }
                        >
                            <Button
                                onClick={() => {
                                    setShowModal(true);
                                }}
                                theme="float"
                            >
                                {getHippoText('DSS-COMMON-CALL-ME')}
                            </Button>
                        </div>
                    </GridItem>
                </Grid>
            </WizardPagetemplate>
            {showModal && (
                <CallMeModal
                    activityCode="dss_call_request"
                    showModal={showModal}
                    closeModal={() => {
                        setShowModal(false);
                    }}
                />
            )}
        </>
    );
};

export default CheckoutPage;
